import "./App.css";
import Home from "./components/Home/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signin from "./components/Signin/Signin";
import Dashboard from "./components/Dashboard/Dashboard";
import UserProvider from "./UserProvider";
import PrivateRoute from "./PrivateRoute";
import AdminDashboard from "./components/Dashboard/AdminDashboard";
import EventProvider from "./components/Dashboard/Organiser/Events/EventProvider";
import {UserContext} from './UserContext';
import EventCard from "./components/Home/EventCard/EventCard";
import Completion from "./components/Payment/Completion";
import Payment from "./components/Payment/Payment";
import SysAdmin from "./components/Dashboard/SysAdmin/SysAdmin";
import TicketProvider from "./components/Dashboard/Customer/MyTickets/TicketProvider";
import ViewTicket from "./components/Dashboard/Customer/MyTickets/ViewTicket";
import axios from "axios";

function App() {

  const addTraffic = async() => {
    try {
      axios.post('https://event-finder12.onrender.com/addTraffic');
    } catch (err) {
      console.log(err);
    }
  }


  if(sessionStorage.getItem('visit') === null) {
    sessionStorage.setItem('visit','session-on');
    console.log('traffic')
    addTraffic();
  } 

  console.log(sessionStorage)


  return (
    <div className="App">
      <Router>
      <EventProvider>
        <UserProvider>
        <TicketProvider>
          <Routes>
            <Route exact  path="/" element={<Home />} />
            <Route exact   path="/login" element={<Signin />} />
            <Route exact path="/event/:id" element={<EventCard/>} />
            <Route exact path="/payment/:id/:selectedQuantity" element={<Payment/>} />
            <Route exact path="/completion" element={<Completion />} />
            <Route exact  path="/dashboard" element={<PrivateRoute />}>
            <Route exact  path="/dashboard" element={<Dashboard />} />
            </Route>
            <Route exact  path="/admin-panel" element={<PrivateRoute />}>
            <Route exact  path="/admin-panel" element={<SysAdmin />} />
            </Route>
            <Route exact  path="/admin-dashboard" element={<PrivateRoute />}>
            <Route exact  path="/admin-dashboard" element={<AdminDashboard />} />
            </Route>
          </Routes>
          </TicketProvider>
        </UserProvider>
        </EventProvider>
      </Router>
    </div>
  );
}

export default App;
